// src/utils/authUtils.js

const TOKEN_KEY = 'token';
const USER_INFO_KEY = 'userInfo';

/**
 * 存储带过期时间的 token
 * @param {string} token 
 * @param {number} expiresIn 有效期（毫秒）
 */
export function setToken(token, expiresIn = 1 * 60 * 60 * 1000) {
  const expireTime = Date.now() + expiresIn;
  sessionStorage.setItem(TOKEN_KEY, JSON.stringify({ token, expireTime }));
}

/**
 * 获取当前 token
 * @returns {string|null}
 */
export function getToken() {
  const tokenData = sessionStorage.getItem(TOKEN_KEY);
  if (!tokenData) return null;

  const { token, expireTime } = JSON.parse(tokenData);

  if (Date.now() > expireTime) {
    removeToken(); // 如果 token 过期，则清除
    return null;
  }

  return token;
}

/**
 * 移除 token
 */
export function removeToken() {
  sessionStorage.removeItem(TOKEN_KEY);
}

/**
 * 检查 token 是否存在且未过期
 * @returns {boolean}
 */
export function isAuthenticated() {
  return !!getToken();
}

/**
 * 存储用户信息
 * @param {Object} userInfo 用户信息对象
 */
export function setUserInfo(userInfo) {
  sessionStorage.setItem(USER_INFO_KEY, JSON.stringify(userInfo));
}

/**
 * 获取当前用户信息
 * @returns {Object|null}
 */
export function getUserInfo() {
  const userInfoData = sessionStorage.getItem(USER_INFO_KEY);
  if (!userInfoData) return null;
  return JSON.parse(userInfoData);
}

/**
 * 移除用户信息
 */
export function removeUserInfo() {
  sessionStorage.removeItem(USER_INFO_KEY);
}